var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var CurrentInning = /** @class */ (function (_super) {
    __extends(CurrentInning, _super);
    function CurrentInning() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrentInning.prototype.render = function () {
        return (React.createElement("span", { className: "rj-baseball-scoreboard-current-inning" }, "" + this.props.currentInning + this.props.partsPhrase + " " + this.props.inningsPhrase));
    };
    return CurrentInning;
}(React.PureComponent));
export { CurrentInning };
//# sourceMappingURL=CurrentInning.js.map